<template>
  <div>
    <template v-if="page === 'loading'">
      <div class="text-center mt-5">
        <v-progress-circular
          indeterminate
          color="secondary"
          width="4"
          size="60"
        ></v-progress-circular>
      </div>
    </template>
    <template v-else-if="page === 'user-edit'">
      <user-edit :user="user"></user-edit>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import UserEdit from "./../../components/users/edit";
export default {
  created() {
    this.title = this.$t("users.edit.title2");
  },
  data: () => ({
    page: "loading",
    title: null,
    user: {},
  }),
  metaInfo() {
    return {
      title: this.title,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      try {
        const params = to.params;
        const response = await vm.request({
          url: `/api/users/${params.id}`,
          messages: {
            404: vm.$t("users.errors.404E"),
          },
        });
        vm.user = response.data;
        vm.page = "user-edit";
        vm.title = vm.$t("users.edit.title", { username: vm.user.username });
      } catch (error) {
        vm.page = "error";
        console.log(error);
      }
    });
  },
  methods: {
    ...mapActions({ request: "request" }),
  },
  components: {
    UserEdit,
  },
};
</script>